import { MoodysRating } from '@moment/trading-types/reference-data'

export function compareMoodysRatings(
  rating1: MoodysRating | null,
  rating2: MoodysRating | null,
): number {
  if (!rating1 || !rating2) {
    return 0
  }
  const allRatings = Object.values(MoodysRating)
  const rating1Index = allRatings.indexOf(rating1)
  const rating2Index = allRatings.indexOf(rating2)

  if (rating1Index === rating2Index) return 0
  return rating1Index < rating2Index ? -1 : 1
}

export function convertMoodysRatingToNumber(rating: string) {
  return Object.values(MoodysRating)
    .reverse()
    .indexOf(rating as MoodysRating)
}

export function convertNumberToMoodysRating(number: number) {
  return Object.values(MoodysRating).reverse()[number]
}

// Rating utility functions for slider implementation
// These provide intuitive mapping for sliders

/**
 * Get all Moody's ratings for slider use
 * Order: C (worst) to Aaa (best) - reversed for intuitive slider behavior
 */
export function getSliderMoodysRatings(): MoodysRating[] {
  return Object.values(MoodysRating).reverse()
}

/**
 * Convert Moody's rating to slider value (0 = C, 20 = Aaa)
 * Returns -1 if rating not found
 */
export function convertMoodysRatingToSliderValue(rating: MoodysRating): number {
  const sliderRatings = getSliderMoodysRatings()
  return sliderRatings.indexOf(rating)
}

/**
 * Convert slider value to Moody's rating (0 = C, 20 = Aaa)
 * Returns null if index out of bounds
 */
export function convertSliderValueToMoodysRating(
  value: number,
): MoodysRating | null {
  const sliderRatings = getSliderMoodysRatings()
  return sliderRatings[value] || null
}

/**
 * Get min/max slider bounds for Moody's ratings
 */
export function getMoodysRatingSliderBounds() {
  const sliderRatings = getSliderMoodysRatings()
  return {
    min: 0, // C (worst)
    max: sliderRatings.length - 1, // Aaa (best)
  }
}
